import React from 'react';
import { loadCustomFonts } from './appFonts';

// import { PaletteMode } from '@mui/material';

declare module '@mui/material/styles' {
  // index signature typegradients

  interface TypeGradient {
    [key: string]: string;
  }

  interface CustomShadows {
    [key: string]: string;
  }

  interface BorderImageSource {
    [key: string]: string;
  }

  interface Palette {
    gradient: TypeGradient;
    text: TypeText;
    tertiary: Tertiary;
    bird: BirdTheme;
    shadows: CustomShadows;
    borderImageSource: BorderImageSource;
  }

  interface TypeText {
    primary: string;
    secondary: string;
    tertiary: string;
    contrastText: string;
    disabled: string;
  }

  interface TypeColor {
    Darkest?: string;
    Darker?: string;
    Dark?: string;
    Base?: string;
    Light?: string;
    Lighter?: string;
    Lightest?: string;
    White?: string;
  }

  interface Tertiary {
    main: string;
  }

  interface BirdTheme {
    main: string;
    darkGrey: string;
    light: string;
  }

  interface PaletteOptions {
    gradient?: TypeGradient;
    tertiary?: Tertiary;
    bird?: BirdTheme;
    shadows?: CustomShadows;
    borderImageSource: BorderImageSource;
    // Ink: TypeColor;
    // Sky: TypeColor;
    // Red: TypeColor;
    // Green: TypeColor;
  }

  interface TypeBackground {
    opposite: string;
    light: string;
    dark: string;
    card: string;
  }
  // interface TypographyVariants {
  //   CTA1: React.CSSProperties;
  //   CTA2: React.CSSProperties;
  //   CTA3: React.CSSProperties;
  //   body3: React.CSSProperties;
  //   body4: React.CSSProperties;
  //   Body1: React.CSSProperties;
  //   Body2: React.CSSProperties;
  //   Body3: React.CSSProperties;
  //   Body1Medium: React.CSSProperties;
  //   Body1SemiBold: React.CSSProperties;
  // }

  // // allow configuration using `createTheme`
  // interface TypographyVariantsOptions {
  //   CTA1?: React.CSSProperties;
  //   CTA2?: React.CSSProperties;
  //   CTA3?: React.CSSProperties;
  //   body3?: React.CSSProperties;
  //   body4?: React.CSSProperties;
  //   Body1?: React.CSSProperties;
  //   Body2?: React.CSSProperties;
  //   Body3?: React.CSSProperties;
  //   Body1Medium?: React.CSSProperties;
  //   Body1SemiBold?: React.CSSProperties;
  // }
  interface TypographyVariants {
    title1: React.CSSProperties;
    title2: React.CSSProperties;
    title3: React.CSSProperties;
    body1: React.CSSProperties;
    body2: React.CSSProperties;
    body3: React.CSSProperties;
    label1: React.CSSProperties;
    label2: React.CSSProperties;
    label3: React.CSSProperties;
    CTA1?: React.CSSProperties;
    CTA2?: React.CSSProperties;
  }

  interface TypographyVariantsOptions {
    title1?: React.CSSProperties;
    title2?: React.CSSProperties;
    title3?: React.CSSProperties;
    body1?: React.CSSProperties;
    body2?: React.CSSProperties;
    body3?: React.CSSProperties;
    label1?: React.CSSProperties;
    label2?: React.CSSProperties;
    label3?: React.CSSProperties;
    CTA1?: React.CSSProperties;
    CTA2?: React.CSSProperties;
  }
}
declare module '@mui/material/Typography' {
  // interface TypographyPropsVariantOverrides {
  //   CTA1: true;
  //   CTA2: true;
  //   CTA3: true;
  //   body3: true;
  //   body4: true;
  //   Body1: true;
  //   Body2: true;
  //   Body3: true;
  //   Body1Medium: true;
  //   Body1SemiBold: true;
  // }
  interface TypographyPropsVariantOverrides {
    title1: true;
    title2: true;
    title3: true;
    body1: true;
    body2: true;
    body3: true;
    label1: true;
    label2: true;
    label3: true;
    CTA1: true;
    CTA2: true;
  }
}

declare module '@mui/material/Button' {
  interface ButtonPropsVariantOverrides {
    instavision: true;
  }
}

export const commonTheme = {
  palette: {
    bird: { main: '#18C7D4', light: '#33DBE8' }
  },
  typography: {
    fontFamily: [
      'Epilogue',
      'SF Pro Rounded',
      '-apple-system', // macOS/iOS system font
      'BlinkMacSystemFont', // Older Chrome/Safari system font
      'Segoe UI', // Windows system font
      'Roboto', // Android/Material UI default
      'Helvetica Neue', // Mac fallback
      'Arial', // Generic sans fallback
      'sans-serif' // Final fallback
    ].join(','),
    fontSize: 1, // 16px base (1rem)
    fontWeightBold: 500,

    // h1: {
    //   fontSize: '2rem', // 32px
    //   fontWeight: 500,
    //   lineHeight: 1.1875 // 38 / 32
    // },
    // h2: {
    //   fontSize: '1.375rem', // 22px
    //   fontWeight: 600,
    //   lineHeight: 1.1818 // 26 / 22
    // },
    // h3: {
    //   fontSize: '1.25rem', // 20px
    //   fontWeight: 500,
    //   lineHeight: 1.025 // 20.5 / 20
    // },
    // h4: {
    //   fontSize: '1.125rem', // 18px
    //   fontWeight: 500,
    //   lineHeight: 1.025 // 18.45 / 18
    // },
    // h5: {
    //   fontSize: '1rem', // 16px
    //   fontWeight: 500,
    //   lineHeight: 1.5 // 24 / 16
    // },
    // h6: {
    //   fontSize: '1rem', // 16px
    //   fontWeight: 500,
    //   lineHeight: 1.025 // 16.4 / 16
    // },

    // Call To Action - Epilogue (Regular and Medium)

    CTA1: {
      fontFamily: 'Epilogue, Roboto, sans-serif',
      fontSize: '1.125rem', // 18px
      fontWeight: 500,
      lineHeight: 1.375 // 24 / 18
    },
    CTA2: {
      fontFamily: 'Epilogue, Roboto, sans-serif',
      fontSize: '1rem', // 18px
      fontWeight: 500,
      lineHeight: 1.333 // 24 / 18
    },

    // Titles - Epilogue (Regular and Medium)
    title1: {
      fontFamily: 'Epilogue, Roboto, sans-serif',
      fontSize: '1.125rem', // 18px
      fontWeight: 500,
      lineHeight: 1.333 // 24 / 18
    },
    title2: {
      fontFamily: 'Epilogue, Roboto, sans-serif',
      fontSize: '1rem', // 16px
      fontWeight: 500,
      lineHeight: 1.375 // 22 / 16
    },
    title3: {
      fontFamily: 'Epilogue, Roboto, sans-serif',
      fontSize: '0.875rem', // 14px
      fontWeight: 500,
      lineHeight: 1.429 // 20 / 14
    },

    // Body - SF Pro Rounded (Medium)
    body1: {
      fontFamily: 'SF Pro Rounded, Roboto, sans-serif',
      fontSize: '1rem', // 16px
      fontWeight: 400,
      lineHeight: 1.5 // 24 / 16
    },
    body2: {
      fontFamily: 'SF Pro Rounded, Roboto, sans-serif',
      fontSize: '0.875rem', // 14px
      fontWeight: 400,
      lineHeight: 1.429 // 20 / 14
    },
    body3: {
      fontFamily: 'SF Pro Rounded, Roboto, sans-serif',
      fontSize: '0.75rem', // 12px
      fontWeight: 400,
      lineHeight: 1.5 // 18 / 12
    },

    // Labels - Epilogue Medium
    label1: {
      fontFamily: 'Epilogue, Roboto, sans-serif',
      fontSize: '1.875rem', // 30px
      fontWeight: 500,
      lineHeight: 1.2 // 36 / 30
    },
    label2: {
      fontFamily: 'Epilogue, Roboto, sans-serif',
      fontSize: '1.25rem', // 18px
      fontWeight: 500,
      lineHeight: 1.333 // 24 / 18
    },
    label3: {
      fontFamily: 'Epilogue, Roboto, sans-serif',
      fontSize: '0.875rem', // 14px
      fontWeight: 500,
      lineHeight: 1.429 // 20 / 14
    }
  },
  MuiButton: {
    variants: [
      {
        props: { variant: 'instavision' },
        style: {
          // background:
          //   'linear-gradient(135deg, #E4E4E4 14.2%, #F5F5F5 84.92%)',
          // border: '0.5px solid #ffffff',
          background:
            'linear-gradient(113deg,rgba(228, 228, 228, 1), rgba(241, 241, 241, 1))  padding-box, linear-gradient(356.14deg, #D5D5D5 9.39%, #FFFFFF 88.07%) border-box',
          border: '1px solid transparent',
          borderRadius: '10000px',
          cursor: 'pointer'
        }
      }
    ],
    styleOverrides: {
      root: {
        textTransform: 'none'
      }
    }
  }
};

function AppThemeProvider() {
  // Inject fonts
  React.useEffect(() => {
    loadCustomFonts();
  }, []);
}

export default AppThemeProvider;
